import { removeItem, setItem, getItem } from '@analytics/storage-utils';
import { isObject } from '@analytics/type-utils';

// NOTE - this is a copy of the cookieUtils from the analytics package
// we need to copy it here because hasCookies needs to be modified to
/**
 * Safe JSON parse
 * @param  {*} input - value to parse
 * @return {*} parsed input
 */
function parse(input) {
    let value = input;
    try {
        value = JSON.parse(input);
        if (value === "true")
            return true;
        if (value === "false")
            return false;
        if (isObject(value))
            return value;
        if (parseFloat(value) === value) {
            value = parseFloat(value);
        }
    }
    catch (e) { }
    if (value === null || value === "") {
        return;
    }
    return value;
}
const COOKIE = "cookie";
// NOTE - use of var isSupported also intended;
/* eslint-disable */
var isSupported = hasCookies();
/**
 * Check if browser has cookie support
 * @returns {boolean}
 */
function hasCookies() {
    if (typeof isSupported !== "undefined") {
        return isSupported;
    }
    const tmp = COOKIE + COOKIE;
    try {
        // Try to set cookie
        cookie(tmp, tmp, 1, "/", undefined, true, "none");
        isSupported = document.cookie.indexOf(tmp) !== -1;
        // Cleanup cookie
        removeCookie(tmp);
    }
    catch (e) {
        isSupported = false;
    }
    return isSupported;
}
/**
 * Get a cookie value
 * @param  {string} name - key of cookie
 * @return {string} value of cookie
 */
function getCookie(name) {
    return parse(cookie(name));
}
/**
 * Set a cookie value
 * @param {string} name  - key of cookie
 * @param {string} value - value of cookie
 * @param {string} days  - days to keep cookie
 */
function setCookie(name, value, ttl, path, domain, secure, sameSite) {
    cookie(name, value, ttl, path, domain, secure, sameSite);
}
/**
 * Remove a cookie value.
 * @param {string} name  - key of cookie
 */
function removeCookie(name) {
    return isSupported ? cookie(name, "", -1) : removeItem(name);
}
function cookie(name, value, ttl, path, domain, secure, sameSite) {
    if (typeof window === "undefined")
        return "";
    const isSet = arguments.length > 1;
    /* If cookies not supported fallback to global */
    if (isSupported === false)
        isSet ? setItem(name, value) : getItem(name);
    /* Set values */
    if (isSet) {
        return (document.cookie =
            name +
                "=" +
                encodeURIComponent(value) +
                /* Set TTL set expiration on cookie */
                (!ttl
                    ? ""
                    : "; expires=" +
                        new Date(+new Date() + +ttl * 1000).toUTCString() +
                        // If path set path
                        (!path ? "" : "; path=" + path) +
                        // If domain set domain
                        (!domain ? "" : "; domain=" + domain) +
                        // If same-site set same-site
                        (!sameSite ? "; SameSite=lax" : "; SameSite=" + sameSite) +
                        // If secure set secure
                        (!secure ? "" : "; secure")));
    }
    /* Get values */
    return decodeURIComponent((("; " + document.cookie).split("; " + name + "=")[1] || "").split(";")[0]);
}

export { COOKIE, parse as default, getCookie, hasCookies, removeCookie, setCookie };
